<div #buttonContent class="h-100 cta-button-widget">
  <finx-button
    [labeltext]="buttonLabel"
    [loadingText]="buttonLoadingText"
    [isLoadingState]="isLoadingState"
    class="pointer-events-none d-flex"
    [buttonStyle]="!isAllowedGlobalStyling ? contentStyle : {}"
    [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100'"
    [leftIcon]="lefticon"
    [rightIcon]="righticon"
    [rightIconSize]="rightIconStyles"
    [leftIconSize]="leftIconStyles"
    (click)="doAction()"
    [disabled]="!isButtonActive"
    [class.disabled-class]="!isButtonActive"
    [activationDelaySeconds]="activationDelaySeconds"
    [style.height]="'100%'"
    [class.d-none]="isButtonHideShow"
    [class.mandatory-cta-button]="!isAllowedGlobalStyling"
    [isAllowedGlobalStyling]="isAllowedGlobalStyling"
    [globalLoadingIndicatorType]="globalLoadingIndicatorType"
    [globalLoadingText]="globalLoadingText"
  ></finx-button>
</div>
